var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"1200px"},attrs:{"id":"schedule"}},[_c('h1',{staticClass:"title",attrs:{"data-aos":"fade-up"}},[_vm._v("Schedule")]),_c('Hyperlink',{staticClass:"tournament-link",attrs:{"asButton":"","pulse":"","onClick":() => _vm.$router.push({ path: 'tournaments' })}},[_vm._v("Sign up here ")]),_c('schedule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }